import { __awaiter, __generator } from "tslib";
import { Microsoft365Ring } from '@1js/search-page-bootstrapper';
export function getRing(searchConfigPromise) {
    return __awaiter(this, void 0, void 0, function () {
        var searchConfig;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, searchConfigPromise];
                case 1:
                    searchConfig = _a.sent();
                    if (searchConfig.fastSearchUXEnvironment === 'prod') {
                        return [2 /*return*/, Microsoft365Ring.generalAudience];
                    }
                    return [2 /*return*/, Microsoft365Ring.outer];
            }
        });
    });
}
//# sourceMappingURL=getRing.js.map